import { Component, Input } from '@angular/core';

@Component({
  selector: 'shared-title',
  templateUrl: './title.component.html'
})
export class TitleComponent {

  @Input('title')
  public title: string = '';

  @Input('description')
  public description: string = '';
}